import { i18nMark } from 'lingui-react';

const messages = {
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  serial: i18nMark('Serial'),
  year: i18nMark('Year'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/AssetOverview/messages.js